<template>
  <div class="event-qr d2lBlack_bg">
    <div class="flex items-center justify-center height-100">
      <div class="row text-center">
        <div class="col-md-12">
          <h1 class="d2lWhite_txt">{{ $route.params.eventId | eventDisplayName }} Event QR Code</h1>
          <div class="inline-block">
            <div ref="qrcode" v-html="qrCodeMarkup"></div>
          </div>
        </div>

        <div class="col-md-12 margin-top">
          <a ref="downloadqr" :href="qrDataURL" class="btn" download="learner-type-qr">Download Code</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import qrMixin from '../mixins/qr';
import globalMixin from '../mixins/global';

export default {
  mixins: [ qrMixin, globalMixin ],

  mounted() {
    this.generateQR();
  },
}
</script>

<style scoped>
  .event-qr {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
</style>
